<template>
    <fieldset :disabled="loading">
        <div class="mb-3">
            <label for="first_name">
                {{ $t("booking.inputs.first_name.label") }}:
            </label>

            <input type="text" class="form-control"
                   name="first_name"
                   id="first_name"
                   v-model="formData.first_name"
                   maxlength="50"
                   :placeholder="$t('booking.inputs.first_name.placeholder')"
                   required>
        </div>

        <div class="mb-3">
            <label for="last_name">
                {{ $t("booking.inputs.last_name.label") }}:
            </label>

            <input type="text" class="form-control"
                   name="last_name"
                   id="last_name"
                   v-model="formData.last_name"
                   maxlength="50"
                   :placeholder="$t('booking.inputs.last_name.placeholder')"
                   required>
        </div>

        <div class="mb-3">
            <label for="email">
                {{ $t("booking.inputs.email.placeholder") }}:
            </label>

            <input type="email" class="form-control"
                   name="email"
                   id="email"
                   v-model="formData.email"
                   maxlength="255"
                   :placeholder="$t('booking.inputs.email.placeholder')"
                   required>
        </div>

        <div class="mb-3">
            <label for="phone">
                {{ $t("booking.inputs.phone.placeholder") }}:
            </label>

            <input type="text" class="form-control"
                   name="phone"
                   id="phone"
                   v-model="formData.phone"
                   maxlength="50"
                   :placeholder="$t('booking.inputs.phone.placeholder')"
                   required>
        </div>

    </fieldset>
</template>

<script>
export default {
    props: {
        loading: {
            required: true,
            type: Boolean,
        },
        formData: {
            required: true,
            type: Object,
        },
    },
}
</script>

<style scoped>

</style>
